import React, {useState, useEffect} from "react";
import { Box, Button, Card, Grid, TextField } from "@mui/material";
import { useAuth } from "../../Context/AuthContext";
import { collection, onSnapshot } from 'firebase/firestore';
import { db } from "../../../firebase/firebaseConfig";
import Alerta from "../../../components/Alerta";
import agregarContacto from "../../../firebase/contactanos/agregarContacto";

const CardContactanos = () => {
    const isItem = true;
    const [nombreContacto, setNombreContacto] = useState('');
    const [apellidoContacto, setApellidoContacto] = useState('');
    const [correo, setCorreo] = useState('');
    const [telefono, setTelefono] = useState('');
    const [nombreCompania, setNombreCompania] = useState('');
    const [descripcion, setDescripcion] = useState('');
    const [estadoAlerta, setEstadoAlerta] = useState(false);
    const [alerta, setAlerta] = useState({});
    const [infoContactanos, setInfoContactanos] = useState([]);
    const {usuario} = useAuth();

    useEffect(() => {
        onSnapshot(collection(db, 'pagecontactanoscalocho'),
            (snapshot) => {
                const arregloInfoContactanos = snapshot.docs.map((docInfoContactanos) => {
                    return {...docInfoContactanos.data(), id: docInfoContactanos.id};
                })

                setInfoContactanos(arregloInfoContactanos);
            },
            (error) => {
                console.log(error);
            }
        );
    }, []);

    const handleChange = (e) => {
        if(e.target.name === ''){

        } else if(e.target.name === 'nombre'){
            setNombreContacto(e.target.value);
        } else if(e.target.name === 'apellidos'){
            setApellidoContacto(e.target.value);
        } else if(e.target.name === 'correo'){
            setCorreo(e.target.value);
        } else if(e.target.name === 'telefono'){
            setTelefono(e.target.value);
        } else if(e.target.name === 'compania'){
            setNombreCompania(e.target.value);
        } else if (e.target.name === 'descripcion'){
            setDescripcion(e.target.value);
        }
    }

    const handleSubmit = async(e) => {
        e.preventDefault();

        try {

            if (nombreContacto !== '' || apellidoContacto !== '' || correo !== '' || telefono !== '' || nombreCompania !== '' || descripcion !== ''){

                agregarContacto({
                    nombreContacto: nombreContacto,
                    apellidoContacto: apellidoContacto,
                    correo: correo,
                    telefono: telefono,
                    nombreCompania: nombreCompania,
                    descripcion: descripcion,
                    uidUsuario: usuario.uid
                });
    
                //Limpiar los campo de la tarjeta de contactanos
                setNombreContacto('');
                setApellidoContacto('');
                setCorreo('');
                setTelefono('');
                setNombreCompania('');
                setDescripcion('');
                
                //Mostrar el mensaje de exxito
                setEstadoAlerta(true);
                setAlerta({ tipo: 'exito', mensaje: 'La información del contacto ha sido enviada' });
            } else {
                setEstadoAlerta(true);
                setAlerta({ tipo: 'error', mensaje: 'Error al enviar la información' });
            }
        } catch (error) {
            console.error(error);
            setEstadoAlerta(true);
            setAlerta({ tipo: 'error', mensaje: 'Error al enviar la información' });
        }

    }
    
    return(
        <Box onSubmit={handleSubmit} component="form" sx={{
            width: '50%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            padding: '16px',
            boxSizing: 'border-box',
        }}>
            <Card sx={{ 
                justifyContent: 'space-between', 
                alignItems: 'center', 
                flexDirection: 'column',
                width: '100%',
                maxWidth: '600px',   // Tamaño máximo
                minWidth: '300px',   // Tamaño mínimo
                padding: '16px',
            }}>
                <Grid container spacing={1} sx={{
                    width: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                }}>
                    <Grid item xs={12}>
                        <TextField 
                            required
                            id="nombre"
                            name="nombre"
                            label="Nombre(s)"
                            size="small"
                            value={nombreContacto}
                            onChange={handleChange}
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField 
                            required
                            id="apellidos"
                            name="apellidos"
                            label="Apellido(s)"
                            size="small"
                            fullWidth
                            onChange={handleChange}
                            value={apellidoContacto}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField 
                            required
                            id="correo"
                            name="correo"
                            label="Correo electrónico"
                            size="small"
                            fullWidth
                            value={correo}
                            onChange={handleChange}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField 
                            required
                            id="telefono"
                            name="telefono"
                            label="Teléfono"
                            size="small"
                            fullWidth
                            value={telefono}
                            onChange={handleChange}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField 
                            required
                            id="compania"
                            name="compania"
                            label="Nombre de la compañía"
                            size="small"
                            fullWidth
                            value={nombreCompania}
                            onChange={handleChange}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField 
                            required
                            id="descripcion"
                            name="descripcion"
                            label="Descripción"
                            size="small"
                            fullWidth
                            multiline
                            value={descripcion}
                            onChange={handleChange}
                        />
                    </Grid>
                    <Grid item xs={12}>
                    <Button item={isItem.toString()}
                            variant="outlined"
                            fullWidth
                            size="small"
                            type="submit"
                            sx={{ mt: 3, mb: 2 }}
                        >Enviar</Button>
                    </Grid>
                </Grid>
            </Card>
            <Alerta 
                tipo={alerta.tipo}
                mensaje={alerta.mensaje}
                estadoAlerta={estadoAlerta}
                setAlerta={setEstadoAlerta}
            />
        </Box>
    );
};

export default CardContactanos;
